import React, { useState, useEffect } from 'react'
import { FormField, SemanticWIDTHS } from 'semantic-ui-react'
import { PatternFormat } from 'react-number-format'
import { useForm, Field } from 'react-final-form'
import { toast } from 'react-toastify'

import { useFieldError } from '../../../hooks/useFieldError'
import { CepData, getCep } from '../../../services/address'

import { Loader } from './styles'

interface PostalCodeInputProps {
  id?: string
  name: string
  label?: string
  required?: boolean
  disabled?: boolean
  width?: SemanticWIDTHS
  fluid?: boolean
  onSuccess?: (data: CepData) => void
  autoComplete?: string
}

const mask = '#####-###'

export const PostalCodeInput: React.FC<PostalCodeInputProps> = ({
  name,
  onSuccess,
  id = name,
  autoComplete,
  ...rest
}) => {
  const form = useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    form.registerField(name, () => undefined, {})
  }, [])

  function searchPostalCode(postalCode: string) {
    const error = 'As informações do CEP digitado não foram encontradas'

    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => getCep(postalCode))
      .then(data => onSuccess?.(data))
      .catch(() => toast.warn(error))
      .finally(() => setLoading(false))
  }

  return (
    <Field name={name}>
      {({ input, meta }) => {
        const error = useFieldError({ input, meta })

        const handleValueChange = (values: any) => {
          // Atualiza o valor no react-final-form
          input.onChange(values.value)
        }

        const handleBlur = (event: any) => {
          input.onBlur(event)
          // Chama a função original onBlur do componente
          // if (onBlur) {
          //   onBlur(event)
          // }
        }

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const value = event.target.value.replace(/\D/g, '')

          // form.change(name, value) // Removido, pois será tratado por onValueChange
          handleValueChange({ value })

          if (value.length < 8) return

          searchPostalCode(value)
        }

        return (
          <>
            <FormField
              {...rest}
              id={id}
              autoComplete={autoComplete}
              control={PatternFormat}
              format={mask}
              onChange={handleChange}
              value={input.value || ''}
              error={error}
              onValueChange={handleValueChange}
              onBlur={handleBlur}
              onFocus={input.onFocus}
            />
            <Loader size="tiny" active={loading} inline />
          </>
        )
      }}
    </Field>
  )
}
